import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import routes from "../routes";
import { Loader } from "rsuite";

const loading = <Loader backdrop content="loading..." vertical />;

const AppContent = () => {
  return (
    <Suspense fallback={loading}>
      <Routes>
        {routes.map((route, idx) => {
          return (
            route.element && (
              <Route
                key={idx}
                path={route.path}
                exact={route.exact}
                name={route.name}
                element={<route.element />}
              />
            )
          );
        })}
      </Routes>
    </Suspense>
  );
};

export default AppContent;
